<template>
  <v-autocomplete
    v-bind="$attrs"
    :items="items"
    :menu-props="{ closeOnClick: true }"
    hide-selected
    outlined
    dense
    :hide-details="true"
    :label="labelField"
    v-model="value"
    :item-value="idField"
    :item-text="nameField"
    class="pt-0"
    multiple
  >
    <template v-slot:prepend-item>
      <v-list-item
        ripple
        @mousedown.prevent
        @click="toggleSelectAll(attribute)"
      >
        <v-list-item-action>
          <v-icon>
            {{ selectAllIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Basculer Séléction
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:item="{ item }">
      {{ item[nameField] }}
    </template>
    <template v-slot:selection="{ selected, item }">
      <v-chip
        small
        :value="selected"
        close
        @click:close="handleInputRemove(item)"
      >
        {{ item[shortnameField] || item[nameField] }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  name: 'FilterAutocomplete',
  props: {
    namespace: {
      type: String,
      required: true,
    },
    labelField: {
      type: String,
      default: '',
    },
    attribute: {
      type: String,
      required: true,
    },
    idField: { type: String, required: true },
    nameField: { type: String, required: true },
    shortnameField: { type: String, required: true },
  },
  methods: {
    handleInputRemove(item) {
      const newValues = this.value.filter((el) => el !== item[this.idField]);
      this.handleInputChange(newValues);
    },
    handleInputChange(values) {
      this.$store.dispatch(`${this.namespace}/setFilterAttribute`, {
        attribute: this.attribute,
        values,
        useDelay: true,
      });
    },
    toggleSelectAll(attribute) {
      return this.$store.dispatch(
        `${this.namespace}/toggleAttribute`,
        attribute
      );
    },
  },
  computed: {
    value: {
      get() {
        const attribute = this.$store.getters[
          `${this.namespace}/attributesObj`
        ][this.attribute];
        return attribute ? attribute.values : null;
      },
      set(values) {
        this.handleInputChange(values);
      },
    },
    items() {
      return this.$store.getters[`${this.namespace}/attributesObjRef`][
        this.attribute
      ].values;
    },
    allSelected() {
      return this.value.length === this.items.length;
    },
    someSelected() {
      return this.value.length > 0 && !this.allSelected;
    },
    selectAllIcon() {
      if (this.allSelected) return 'mdi-close-box';
      if (this.someSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
};
</script>
